<script lang="ts" setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { brandingQueries } from '@services/overig/queries/BrandingQueries';
import VMenu from '@shared/component/VMenu/VMenu.vue';
import { useQuery } from '@tanstack/vue-query';
import { computed, ref } from 'vue';

const menu = ref<InstanceType<typeof VMenu>>();

const { data: brandingData } = useQuery({
  ...brandingQueries.fetchBranding(),
  select: (result) => result.data.result,
});

const model = computed(() => {
  const items = [];

  if (brandingData.value?.telefoonnummer) {
    items.push({
      icon: ['far', 'phone'],
      label: brandingData.value.telefoonnummer,
      url: `tel:${brandingData.value.telefoonnummer}`,
    });
  }

  if (brandingData.value?.emailadres) {
    items.push({
      icon: ['far', 'envelope'],
      label: brandingData.value.emailadres,
      url: `mailto:${brandingData.value.emailadres}`,
    });
  }

  if (brandingData.value?.website) {
    items.push({
      icon: ['far', 'globe-pointer'],
      label: 'Website',
      target: '_blank',
      url: `${brandingData.value.website.startsWith('http') ? '' : 'https://'}${brandingData.value.website}`,
    });
  }

  return items;
});

function toggleMenu(event: Event) {
  menu.value?.toggle(event);
}
</script>

<template>
  <div
    v-if="brandingData?.emailadres || brandingData?.telefoonnummer || brandingData?.website"
    class="relative flex"
  >
    <button
      class="flex cursor-pointer items-center gap-1 border-none bg-transparent px-3 text-sm text-inherit outline-none lg:px-6"
      type="button"
      @click="toggleMenu"
    >
      <FontAwesomeIcon :icon="['far', 'users']" />

      <span class="max-sm:hidden">Contact</span>
    </button>

    <VMenu append-to="self" class="left-auto right-0 top-full" :model popup ref="menu" />
  </div>
</template>
